module.exports = __webpack_public_path__ + "static/media/ZEV Video Script Draft_1651239826109.ef37b36a.docx";